import router from '@/common/router';
import store from '@/common/vuex';
import { ApiSidebarMenu } from '@/common/api';
import { getCookie } from './utils/cookie';

router.beforeEach(async (to, from, next) => {
    const token = getCookie('token');
    // 退出之后的重定向地址
    const { dccTenantAjmdLogoutUrl, tenantType } = store.getters.userInfo;
    if (token) {
        // 获取用户信息
        const data =
            tenantType >= 0
                ? store.getters.userInfo
                : await store.dispatch('set_userInfo');
        document.title =
            data.tenantType === 3 ? '阿基米德Saas系统' : '梦饷云Saas系统';
        // 如果该用户没有选择过版本，就强制回到登录页面选择版本
        if (!data.isSetVersionId && to.path !== '/login') {
            next({
                path: '/login'
            });
        } else if (to.path === '/login' && data.isSetVersionId) {
            next({
                path: '/any'
            });
        } else {
            // 请求权限路由
            if (store.getters.permissionRouters.length <= 0) {
                const routes = (await ApiSidebarMenu()) || {};
                // 缓存权限路由
                store.dispatch('set_permissionRouters', routes.data);
            }
            next();
        }
    } else if (dccTenantAjmdLogoutUrl) {
        window.location.href = dccTenantAjmdLogoutUrl;
    } else if (to.meta.requireAuth) {
        // 如果进入的页面需要授权就先进入到登录页面
        next({
            path: '/login'
        });
    } else {
        next();
    }
});
